var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStoploss100 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#stoploss-100_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.195 3.2a.6.6 0 0 0-1.2 0h1.2Zm-1.2 0v6.07h1.2V3.2h-1.2Z",
  fill: "#EB1C24"
}), /*#__PURE__*/React.createElement("mask", {
  id: "stoploss-100_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.595 0a3.035 3.035 0 0 0-3.034 3.035v3.919a4.595 4.595 0 1 0 6.07 0v-3.92A3.035 3.035 0 0 0 6.594 0Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.56 6.954 4.685 8.23l.577-.508v-.768h-1.7Zm6.07 0h-1.7v.768l.577.508L9.63 6.954Zm-4.37-3.92c0-.736.598-1.334 1.335-1.334v-3.4a4.735 4.735 0 0 0-4.734 4.735h3.4Zm0 3.92v-3.92h-3.4v3.92h3.4Zm-1.56 3.45c0-.865.378-1.641.984-2.174L2.438 5.678A6.284 6.284 0 0 0 .3 10.405h3.4ZM6.595 13.3A2.895 2.895 0 0 1 3.7 10.405H.3A6.295 6.295 0 0 0 6.595 16.7v-3.4Zm2.896-2.895c0 1.599-1.297 2.895-2.896 2.895v3.4a6.295 6.295 0 0 0 6.296-6.295h-3.4ZM8.507 8.23c.606.533.984 1.309.984 2.175h3.4c0-1.884-.83-3.576-2.138-4.727L8.507 8.23ZM7.93 3.035v3.919h3.4v-3.92h-3.4ZM6.595 1.7c.737 0 1.335.598 1.335 1.335h3.4A4.735 4.735 0 0 0 6.595-1.7v3.4Z",
  fill: "#EB1C24",
  mask: "url(#stoploss-100_svg__b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.595,
  cy: 10.494,
  r: 1.994,
  fill: "#EB1C24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.497.867h2.081M10.497 2.601h2.081M10.497 4.335h2.081M10.497 6.07h2.081",
  stroke: "#EB1C24"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "stoploss-100_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v15H0z"
})))));
export default SvgStoploss100;